import Vue from 'vue'
import Router from 'vue-router'
import i18n from "@/lang";
import {
  consumeNavigationSource,
  getScrollPosition,
  setPageScrollPosition
} from '@/utils/pageNavigation'

Vue.use(Router)
Vue.use(i18n)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
 title: 'title'               the name show in submenu and breadcrumb (recommend set)
 icon: 'svg-name'             the icon show in the sidebar,
 }
 **/
export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {path: '/forgotPwd', component: () => import('@/views/login/forgotPwd.vue'), hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  {
    path: '',
    component: Layout,
    redirect: '/home',
    meta: {title: i18n.t('system.home'), icon: 'home', keepRootLayout: true},
    hidden: true,
    children: [
      {
        path: 'home',
        name: 'home',
        component: () => import('@/views/home/index'),
        meta: {title: i18n.t('menu.dashboard'), icon: 'dashboard', keepAlive: true}
      },
      {
        path: 'home/statisticsDetail',
        name: 'homeStatisticsDetail',
        component: () => import('@/views/home/statisticsDetail'),
        meta: {
          title: i18n.t('home.statisticsDetailTitle'),
          detailPage: true,
          defaultParentName: 'home'
        },
        hidden: true
      },
      {
        path: 'profile',
        name: 'profile',
        component: () => import('@/views/layout/components/profile'),
        meta: {title: i18n.t('system.myAccount'), icon: 'dashboard'},
        hidden: true
      },
      {
        path: '/messageIM',
        name: 'messageIM',
        component: () => import('@/views/IM/im.vue'),
        meta: {title: i18n.t('im.messageNotifications'), icon: 'review'},
        hidden: true
      },
       // 站内信通知
      {
        path: '/notifications',
        name: 'Notifications',
        component: () => import('@/views/IM/notifications/index.vue'),
        meta: {title: i18n.t('im.messageNotifications'), icon: 'review'},
        hidden: true
      },
    ]
  },
  {path: '/IM', component: () => import('@/views/IM/im.vue'), hidden: true},
  {path: '/mobileIM', component: () => import('@/views/IM/mobileIM'), hidden: true},
  {
    path: '/detailLayout',
    name: 'detailLayout',
    redirect: '/newOrderDetail',
    component: () => import('@/views/detailLayout/index.vue'),
    hidden: true,
    meta: {title: i18n.t('order.orderDetails')},
    children: [
      {
        path: '/newOrderDetail',
        name: 'newOrderDetail',
        component: () => import('@/views/oms/platformOrder/orderDetail/index.vue'),
        meta: {
          title: i18n.t('order.orderDetails'),
          detailPage: true,
          defaultParentName: 'platformOrder'
        },
      },
      {
        path: '/afterSaleDetail',
        name: 'afterSaleDetail',
        component: () => import('@/views/oms/platformOrder/afterSaleDetail/index.vue'), //orderAuditList
        meta: {
          title: i18n.t('menu.AfterSalesDetails'),
          icon: 'review',
          detailPage: true,
          defaultParentName: 'orderAuditList'
        },
        hidden: true
      },
      {
        path: '/payment',
        name: 'payment',
        component: () => import('@/views/payment/PayMent.vue'),
        meta: {
          title: i18n.t('menu.payment'),
          icon: 'payment',
          detailPage: true,
          defaultParentName: 'platformOrder'
        },
        hidden: true
      },
      {
        path: '/stripePayment',
        name: 'stripePayment',
        component: () => import('@/views/payment/stripe/index.vue'),
        meta: {
          title: i18n.t('payment.stripePayment'),
          icon: 'bankCard1',
          detailPage: true,
          defaultParentName: 'platformOrder'
        },
        hidden: true
      },
      {
        path: '/payment/wechat',
        name: 'wechatPayment',
        component: () => import('@/views/payment/wechat/index.vue'),
        meta: {
          title: i18n.t('payment.wechatPayment'),
          icon: 'wechat',
          detailPage: true,
          defaultParentName: 'platformOrder'
        },
        hidden: true
      }
    ]
  },
]

export const asyncRouterMap = [
  // 货主
  {
    path: '/shop',
    component: Layout,
    redirect: '/shop/productVerify',
    name: 'cms',
    meta: {title: i18n.t('menu.shopManagement'), icon: 'ums', keepRootLayout: true},
    children: [
      {
        path: 'productVerify',
        name: 'productVerify',
        component: () => import('@/views/pms/verify/productVerify'),
        meta: {title: i18n.t('menu.productVerify'), icon: 'product-cate', keepAlive: true}
      },
      // {
      //   path: 'platformProductDetail',
      //   name: 'platformProductDetail',
      //   component: () => import('@/views/pms/platformProduct/productDetail.vue'),
      //   meta: {title: i18n.t('menu.productDetails')},
      //   hidden: true
      // },
      {
        path: 'platformProductDetail',
        name: 'platformProductDetail',
        component: () => import("@/views/pms/platformProduct/newProductDetail/index.vue"),
        meta: {
          title: i18n.t('menu.productDetails'),
          detailPage: true,
          defaultParentName: 'productVerify'
        },
        hidden: true
      },
      {
        path: 'shopApply',
        name: 'shopApply',
        component: () => import('@/views/cms/shopApply/index'),
        meta: {title: i18n.t('menu.shopApplyList'), icon: 'ums-admin', keepAlive: true}
      },
      {
        path: 'reviewShop',
        name: 'reviewShop',
        component: () => import('@/views/cms/shopApply/reviewShop'),
        meta: {
          title: i18n.t('menu.reviewShopDetail'),
          icon: 'ums-admin',
          detailPage: true,
          defaultParentName: 'shopApply'
        },
        hidden: true
      },
      {
        path: 'shopList',
        name: 'shopList',
        component: () => import('@/views/cms/shop/index.vue'),
        meta: {title: i18n.t('menu.shopList'), icon: 'ums-admin', keepAlive: true}
      },
      {
        path: 'quotation',
        name: 'quotation',
        component: () => import('@/views/quotation/index'),
        meta: {
          title: i18n.t('menu.quotation'),
          icon: 'document',
          detailPage: true,
          defaultParentName: 'shopList'
        },
        hidden: true
      }
    ]
  },
  // 仓库
  {
    path: '/warehouse',
    component: Layout,
    redirect: '/warehouse/audit',
    name: 'warehouse',
    meta: {title: i18n.t('settings.warehouse'), icon: 'table', keepRootLayout: true},
    children: [
      {
        path: 'audit',
        name: 'warehouseAudit',
        component: () => import('@/views/pms/verify/warehouseVerify'),
        meta: {title: i18n.t('menu.warehouseAudit'), icon: 'product-list', keepAlive: true},
      },
      {
        path: 'warehouseLocation',
        name: 'warehouseLocation',
        component: () => import('@/views/settings/warehouse'),
        meta: {title: i18n.t('menu.warehouseList'), icon: 'product-list', keepAlive: true},
      },
    ]
  },
  // 订单
  {
    path: '/oms',
    component: Layout,
    redirect: '/oms/platformOrder',
    name: 'oms',
    meta: {title: i18n.t('menu.order'), icon: 'order', keepRootLayout: true},
    children: [
      {
        path: 'platformOrder',
        name: 'platformOrder',
        component: () => import('@/views/oms/platformOrder/newIndex/newIndex.vue'),
        meta: {title: i18n.t('menu.platformOrders'), icon: 'product-list', keepAlive: true}
      },
      {
        path: 'orderAuditList',
        name: 'orderAuditList',
        component: () => import('@/views/oms/platformOrder/orderAuditList'), //orderAuditList
        meta: {title: i18n.t('menu.orderAuditList'), icon: 'review', keepAlive: true}
      },
      {
        path: 'returnReason',
        name: 'returnReason',
        component: () => import('@/views/oms/returnReason/index.vue'),
        meta: {
          title: i18n.t('order.returnReason'),
          icon: 'product-list',
          keepAlive: true
        },
      },
      {
        path: 'returnParcel',
        name: 'returnParcel',
        component: () => import('@/views/oms/returnParcel'),
        meta: {title: i18n.t('returnParcel.managementTitle'), icon: 'restock'},
        hidden: true
      },
    ]
  },
  // 财务
  {
    path: '/financial',
    component: Layout,
    redirect: '/financial/pendingSettlement',
    name: 'financial',
    meta: {title: i18n.t('menu.financial'), icon: 'order', keepRootLayout: true},
    children: [
      // 结算
      {
        path: 'pendingSettlement',
        name: 'pendingSettlement',
        component: () => import('@/views/financial/pendingSettlement/index.vue'),
        meta: {title: i18n.t('menu.pendingSettlement'), icon: 'product-list', keepAlive: true}
      },
      {
        path: 'settledOrders',
        name: 'settledOrders',
        component: () => import('@/views/financial/settledOrders/index.vue'),
        meta: {title: i18n.t('menu.settledOrders'), icon: 'product-list', keepAlive: true}
      },
      {
        path: 'settleDetails',
        name: 'settleDetails',
        component: () => import('@/views/financial/pendingSettlement/settleDetails.vue'),
        meta: {
          title: i18n.t('menu.settleDetails'),
          icon: 'product-list',
          detailPage: true,
          defaultParentName: 'pendingSettlement'
        },
        hidden: true
      },
      // 对账
      {
        path: 'reconciliation',
        name: 'reconciliation',
        component: () => import('@/views/financial/reconciliation/index.vue'),
        meta: {title: i18n.t('menu.reconciliationList'), icon: 'product-list', keepAlive: true}
      },
      // 余额
      {
        path: 'buyerBalance',
        name: 'buyerBalance',
        component: () => import('@/views/financial/buyerBalance/index.vue'),
        meta: {title: i18n.t('menu.buyerBalance'), icon: 'product-list', keepAlive: true}
      },
      {
        path: 'buyerBalanceDetail',
        name: 'buyerBalanceDetail',
        component: () => import('@/views/financial/buyerBalance/detail.vue'),
        meta: {
          title: i18n.t('menu.buyerBalance'),
          icon: 'review',
          detailPage: true,
          defaultParentName: 'buyerBalance'
        },
        hidden: true
      },
      {
        path: 'sellerBalance',
        name: 'sellerBalance',
        component: () => import('@/views/financial/sellerBalance/index.vue'),
        meta: {title: i18n.t('menu.sellerBalance'), icon: 'product-list', keepAlive: true}
      },
      {
        path: 'sellerBalanceDetail',
        name: 'sellerBalanceDetail',
        component: () => import('@/views/financial/sellerBalance/detail.vue'),
        meta: {
          title: i18n.t('menu.sellerBalance'),
          icon: 'review',
          detailPage: true,
          defaultParentName: 'sellerBalance'
        },
        hidden: true
      },
      {
        path: 'settlementDebt',
        name: 'settlementDebt',
        component: () => import('@/views/financial/settlementDebt/index.vue'),
        meta: {title: i18n.t('menu.settlementDebt'), icon: 'product-list', keepAlive: true}
      },
    ]
  },
  // 小B
  {
    path: '/business',
    component: Layout,
    redirect: '/business/buyer',
    name: 'business',
    meta: {title: i18n.t('menu.business'), icon: 'ums', keepRootLayout: true},
    children: [
      {
        path: 'buyer',
        name: 'buyer',
        component: () => import('@/views/ums/buyer/index'),
        meta: {title: i18n.t('menu.mallUsers'), icon: 'ums-admin', keepAlive: true}
      },
      {
        path: 'buyerDetail',
        name: 'buyerDetail',
        component: () => import('@/views/ums/buyer/details.vue'),
        meta: {
          title: i18n.t('menu.distributorAccountDetails'),
          icon: 'ums-admin',
          detailPage: true,
          defaultParentName: 'buyer'
        },
        hidden: true
      },
      {
        path: 'buyerReview',
        name: 'buyerReview',
        component: () => import('@/views/business/review/index'),
        meta: {title: i18n.t('menu.mallUserAudit'), icon: 'ums-admin', keepAlive: true}
      },
      {
        path: 'reviewDetail',
        name: 'reviewDetail',
        component: () => import('@/views/business/review/detail.vue'),
        meta: {
          title: i18n.t('menu.mallUserReviewDetail'),
          icon: 'ums-admin',
          detailPage: true,
          defaultParentName: 'buyerReview'
        },
        hidden: true
      },
      {
        path: 'comment',
        name: 'comment',
        component: () => import('@/views/business/comment/index.vue'),
        meta: {title: i18n.t('buyer.productReviews'), icon: 'ums-admin', keepAlive: true}
      },
    ]
  },
  // 设置
  {
    path: '/settings',
    component: Layout,
    redirect: '/settings/brand',
    name: 'settings',
    meta: {title: i18n.t('menu.settings'), icon: 'ums', keepRootLayout: true},
    children: [
      {
        path: 'brand',
        name: 'brand',
        component: () => import('@/views/settings/brand'),
        meta: {title: i18n.t('menu.brandManagement'), icon: 'product-brand', keepAlive: true}
      },
      {
        path: 'productCate',
        name: 'productCate',
        component: () => import('@/views/settings/productCate/index'),
        meta: {title: i18n.t('menu.productSort'), icon: 'product-cate', keepAlive: true}
      },
      {
        path: 'specificationsList',
        name: 'specificationsList',
        component: () => import('@/views/settings/specificationsList/index.vue'),
        meta: {title: i18n.t('menu.specificationsList'), icon: 'product-cate', keepAlive: true}
      },
      {
        path: 'bindGroup',
        name: 'bindGroup',
        component: () => import('@/views/settings/productCate/bindGroup'),
        meta: {
          title: i18n.t('menu.parameterBinding'),
          detailPage: true,
          defaultParentName: 'productCate'
        },
        hidden: true
      },
      // {
      //   path: 'unit',
      //   name: 'unit',
      //   component: () => import('@/views/settings/unit/index'),
      //   meta: {title: i18n.t('menu.unitOfMeasurement'), icon: 'product-brand'},
      // }
    ]
  },
  // 模板
  {
    path: '/templates',
    component: Layout,
    redirect: '/settings/brand',
    name: 'Templates',
    meta: {title: i18n.t('menu.template'), icon: 'ums', keepRootLayout: true},
    children: [
      {
        path: 'emailTemplates',
        name: 'emailTemplates',
        component: () => import('@/views/template/email/index.vue'),
        meta: {title: i18n.t('menu.emailTemplates'), icon: 'product-brand', keepAlive: true}
      }
    ]
  },
  // 权限
  {
    path: '/ums',
    component: Layout,
    redirect: '/ums/platformUser',
    name: 'ums',
    meta: {title: i18n.t('menu.Permissions'), icon: 'ums', keepRootLayout: true},
    children: [
      {
        path: 'platformUser',
        name: 'platformUser',
        component: () => import('@/views/ums/platformUser/index'),
        meta: {title: i18n.t('menu.platformUsers'), icon: 'ums-admin', keepAlive: true}
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/ums/role/index'),
        meta: {title: i18n.t('menu.platformRole'), icon: 'ums-role', keepAlive: true}
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/ums/role/allocMenu'),
        meta: {
          title: i18n.t('permission.AssignMenus'),
          detailPage: true,
          defaultParentName: 'role'
        },
        hidden: true
      },
      {
        path: 'allocResource',
        name: 'allocResource',
        component: () => import('@/views/ums/role/allocResource'),
        meta: {
          title: i18n.t('menu.AllocatingResources'),
          detailPage: true,
          defaultParentName: 'role'
        },
        hidden: true
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: {title: i18n.t('menu.menuList'), icon: 'ums-menu', keepAlive: true}
      },
      {
        path: 'menuShop',
        name: 'menuShop',
        component: () => import('@/views/ums/menu/index_shop'),
        meta: {title: i18n.t('menu.shopMenu'), icon: 'ums-menu', keepAlive: true}
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/ums/menu/add'),
        meta: {
          title: i18n.t('menu.addMenu'),
          detailPage: true,
          defaultParentName: 'menu'
        },
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: {
          title: i18n.t('menu.updateMenu'),
          icon: 'ums-menu',
          detailPage: true,
          defaultParentName: 'menu'
        },
        hidden: true
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('@/views/ums/resource/index'),
        meta: {title: i18n.t('menu.resourceList'), icon: 'ums-resource', keepAlive: true}
      },
      {
        path: 'resourceCategory',
        name: 'resourceCategory',
        component: () => import('@/views/ums/resource/categoryList'),
        meta: {
          title: i18n.t('menu.ResourceClassification'),
          detailPage: true,
          defaultParentName: 'resource'
        },
        hidden: true
      },
      {
        path: 'shopRole',
        name: 'shopRole',
        component: () => import('@/views/cms/role'),
        meta: {title: i18n.t('menu.roleList'), icon: 'ums-role', keepAlive: true}
      },
      {
        path: 'SystemConfiguration',
        name: 'SystemConfiguration',
        component: () => import('@/views/cms/SystemConfiguration/index.vue'),
        meta: {title: i18n.t('menu.SystemConfiguration'), icon: 'form', keepAlive: true}
      },
      {
        path: 'commodityZoneEdit',
        name: 'commodityZoneEdit',
        component: () => import('@/views/cms/SystemConfiguration/commodityZoneEdit.vue'),
        meta: {
          title: i18n.t('ums.commodityZoneTitle'),
          detailPage: true,
          defaultParentName: 'SystemConfiguration'
        },
        hidden: true
      },
    ]
  },

  {
    path: '/credit',
    component: Layout,
    redirect: '/credit/creditValueList',
    name: 'creditValue',
    meta: {title: i18n.t('menu.creditValue'), icon: 'creditValue', keepRootLayout: true},
    children: [
      {
        path: 'creditValueList',
        name: 'creditValueList',
        component: () => import('@/views/creditValue/index'),
        meta: {title: i18n.t('menu.creditValueList'), icon: 'creditValueList', keepAlive: true}
      },
    ]
  },


  {path: '*', redirect: '/404', hidden: true}
]

// 解决重复点击菜单会控制台报错bug
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior(to, from, savedPosition) {
    const navigationSource = consumeNavigationSource()
    let position = {x: 0, y: 0}

    if (navigationSource === 'breadcrumb') {
      const scrollTop = getScrollPosition(to.name)
      if (scrollTop !== null) {
        position = {x: 0, y: scrollTop}
      }
    } else if (savedPosition) {
      position = savedPosition
    }

    Vue.nextTick(() => {
      setPageScrollPosition(position)
    })

    return false
  },
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js